import { LEERLINGNUMMER_MAX } from '../lib/leerlingnummer';
import logoUrl from '../assets/pallas-logo.svg';

interface Props {
  melding: string;
  buffer: string;
  bezig: boolean;
}

/** Alleen weergave: de globale scannerhook blijft ook buiten deze overlay actief. */
export function LoginOverlay({ melding, buffer, bezig }: Props) {
  return (
    <div className="login-overlay">
      <div className="login-box">
        <img className="logo-lockup" src={logoUrl} alt="Pallas Athene College" />
        <h1>Leerlingrooster</h1>
        <p>Scan je schoolpas</p>
        <input type="text" placeholder="Leerlingnummer" aria-label="Gescande pascode"
          maxLength={LEERLINGNUMMER_MAX} inputMode="none" autoComplete="off" value={buffer} readOnly />
        <div role="status">{bezig ? 'Even kijken…' : ''}</div>
        <div className="login-error" role="alert">{melding}</div>
      </div>
    </div>
  );
}
